var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-main" }, [
    _c("h2", [_vm._v("WS测试")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "spaceLeft" },
      [
        _c("a-input", {
          staticStyle: { width: "200px" },
          model: {
            value: _vm.wsType,
            callback: function($$v) {
              _vm.wsType = $$v
            },
            expression: "wsType"
          }
        }),
        _vm._v(" "),
        _c("a-input", {
          staticStyle: { width: "200px" },
          model: {
            value: _vm.wsId,
            callback: function($$v) {
              _vm.wsId = $$v
            },
            expression: "wsId"
          }
        }),
        _vm._v(" "),
        _c(
          "a-button",
          {
            on: {
              click: function($event) {
                return _vm.wsInit()
              }
            }
          },
          [_vm._v("连接")]
        ),
        _vm._v(" "),
        _c(
          "a-button",
          {
            on: {
              click: function($event) {
                return _vm.wsOut()
              }
            }
          },
          [_vm._v("断开")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", [_vm._v("\n    " + _vm._s(_vm.wsReceiveMsg) + "\n  ")])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e009aaca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e009aaca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/test/test.vue
// module id = uRnd
// module chunks = 1